import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFilePdf} from "@fortawesome/free-regular-svg-icons";

export const DlBtn = ({district, dlUrl}) => {
  const linkStyle = {
    backgroundColor: "#6666ff",
    cursor: "pointer",
    fontSize: "1.4rem",
  };
  return (
    <>
      {district === "大阪" ? (
        <a
          href="dl/osaka_flyer.pdf?20260511"
          target="_blank"
          rel="noopener noreferrer"
          className="dlBtn"
          style={linkStyle}>
          {district}会場チラシ ダウンロード
          <FontAwesomeIcon icon={faFilePdf} />
        </a>
      ) : district === "九州" ? (
        <a
          href="dl/kyusyu_flyer.pdf?20260511"
          target="_blank"
          rel="noopener noreferrer"
          className="dlBtn"
          style={linkStyle}>
          {district}会場チラシ ダウンロード
          <FontAwesomeIcon icon={faFilePdf} />
        </a>
      ) : district === "東京" ? (
        <a
          href="dl/tokyo_flyer.pdf?20260511"
          target="_blank"
          rel="noopener noreferrer"
          className="dlBtn"
          style={linkStyle}>
          {district}会場チラシ ダウンロード
          <FontAwesomeIcon icon={faFilePdf} />
        </a>
      ) : district === "北陸" ? (
        <a
          href="dl/hokuriku_flyer.pdf?20260511"
          target="_blank"
          rel="noopener noreferrer"
          className="dlBtn"
          style={linkStyle}>
          {district}会場チラシ ダウンロード
          <FontAwesomeIcon icon={faFilePdf} />
        </a>
      ) : null}
    </>
  );
};
